import { FC, useEffect } from 'react';

import { ToggleScale } from '@pp/core/src/components/controls/toggle/Toggle';
import { GameButtonWithTooltip } from '@pp/core/src/components/game/gameButton/gameButton';
import { Icons } from '@pp/core/src/components/icons/iconNames';
import { Logger } from '@pp/core/src/logger/Logger';
import { useAutoplayHiddenFlag } from '@pp/core/src/store/compositeSelectors/useAutoplayHiddenFlag';
import { useCoreDispatch } from '@pp/core/src/store/CoreStore';
import { useBetSlice } from '@pp/core/src/store/slices/bets/selectors';
// import { useConfigSlice } from '@pp/core/src/store/slices/config/selectors';
import { useIsLargerThanExtraWide } from '@pp/core/src/styles/hooks/media';

import { useIsConfirmButtonDisabled } from '../../components/gameGrid/hooks/useIsConfirmButtonDisabled';
import { Toggle } from '../../components/toggle/Toggle';
// import { HIGHFLYER_PT } from '../../config/tableConfigParserOptions';
import { useCrashAutoplaySlice } from '../../store/slices/crashAutoplay/selectors';
import { crashAutoplayActions } from '../../store/slices/crashAutoplay/slice';
import { useInfinityAutoplayHiddenFlag } from '../gameGrid/hooks/useInfinityAutoplayHiddenFlag';

import { BettingFooterConnectedProps } from './BettingFooterConnected';

export const CrashAutoPlayConnected: FC<BettingFooterConnectedProps> = ({ betCode, ...rest }) => {
  const dispatch = useCoreDispatch();
  const totalBet = useBetSlice.bets()?.betSpots[betCode]?.value || 0;
  const hideAutoplay = useAutoplayHiddenFlag();
  // AUTOPLAY
  const isInProgress = useCrashAutoplaySlice.isInProgress(betCode);
  const isOpen = useCrashAutoplaySlice.isOpen(betCode);
  const remainingCount = useCrashAutoplaySlice.getRemainingCount(betCode);
  const isDisabled = useIsConfirmButtonDisabled(betCode);
  const isEnabled = useCrashAutoplaySlice.getInfiniteAutoplayEnabled(betCode) || false;
  const hideInfinteAutoplay = useInfinityAutoplayHiddenFlag();
  const isLargerThanExtraWide = useIsLargerThanExtraWide();
  // const tableVariant = useConfigSlice.getTableVariant();

  useEffect(() => {
    dispatch(crashAutoplayActions.setInfiniteAutoplayAvailable(hideInfinteAutoplay));
  }, [hideInfinteAutoplay]);

  useEffect(() => {
    if (isDisabled && totalBet === 0) {
      dispatch(crashAutoplayActions.setOpenToClose(betCode));
    }
  }, [isDisabled]);

  const toggleOpen = (): void => {
    dispatch(crashAutoplayActions.toggleOpen(betCode));
    Logger.logEvent('click', 'autoplay', Date.now(), 1, '', false);
  };

  if (hideAutoplay) return null;

  const handleOnChange = (): void => {
    dispatch(crashAutoplayActions.setInfiniteAutoplayEnabled(betCode));
  };

  return hideInfinteAutoplay ? (
    <GameButtonWithTooltip
      icon={Icons.Autoplay}
      active={isOpen}
      onClick={toggleOpen}
      grow
      disabled={isDisabled && totalBet === 0}
      badge={isInProgress ? remainingCount : ''}
      {...rest}
      tooltipOptions={{
        text: isInProgress ? 'MODIFY_AUTOPLAY' : 'AUTOPLAY',
        disabled: isOpen,
      }}
    />
  ) : (
    <Toggle
      checked={isEnabled}
      onChange={handleOnChange}
      disabled={isDisabled}
      scale={isLargerThanExtraWide ? ToggleScale.Large : ToggleScale.Medium}
      showIcon={true}
    />
  );
};
